class usersUpdateController{
  constructor(
    $users,
    $companies,
    $auth
  ){

    'ngInject';
    this.$auth = $auth;
    this.$users = $users;
    this.$companies = $companies;
    this.user = this.resolve.items.user;
    this.initialUser = null;
    this.isSpeditor = false;
    this.isBookingAdmin = false;
  }

  $onInit() {
    this.currentUser = this.$auth.user || this.$auth.getUser();
    this.initialUser = JSON.parse(JSON.stringify(this.user));

    this.isSpeditor = this.user.role !== '' && this.user.role !== null;
  }

  get me() {
    return this.currentUser.id === this.user.id;
  }

  get currentCompany() {
    return this.$companies.currentCompany;
  }

  /**
   *
   * @param formUsersUpdate
   */
  $onSubmit( formUsersUpdate, $event ){
    if (this.isSpeditor && (this.user.role === null || this.user.role === '')) {
      const speditorRole = this.$users.getRoleByCode('spedytor');
      this.user.role = speditorRole.uri;
    } else if (!this.isSpeditor) {
      this.user.role = null;
      this.user.speditor_id = null;
    }
    this.$users.update( this.user )
      .then(() => this.initialUser = Object.assign({}, this.user))
      .then(() => this.$onClose($event))
      .then(() => formUsersUpdate.$submitted = false );
  }

  /**
   *
   * @param $event
   */
  $onClose($event){
    $event.preventDefault();
    if (this.$companies.currentCompany) {
      const userIdx = this.$companies.currentCompany.sub.Users.findIndex(user => user.id === this.initialUser.id);
      this.$companies.currentCompany.sub.Users[userIdx] = this.initialUser;
    }
    this.close({$value: 'cancel'});
  }

  get availableOperators() {
    return this.currentCompany.invoice_account.allowed_operators;
  }

  updateOperators(operator) {
		const idx = this.user.operators.indexOf(operator);
		if (idx > -1) {
			this.user.operators.splice(idx, 1);
		} else {
			this.user.operators.push(operator);
		}
		console.log('user', this.user.operators);
		console.log('initial', this.initialUser.operators);
  }

}

export default usersUpdateController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-update/users-update.controller.js
 **/